import ProductService from "@/service/product.service";

export const state = {
	products: [],
}

export const mutations = {
	setProducts(state, products) {
		state.products = products
	},
}

export const actions = {
	async loadActiveProducts({commit}) {
		await ProductService.loadActiveProducts().then(async products => {
			commit('setProducts', products)
		})
	},
}


export default {
	state,
	actions,
	mutations,
};